import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const NoAdvisors = props => {
  return (
    <Svg
      width={105}
      height={114}
      viewBox="0 0 105 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M98.232 37.33S82.871 50.816 100.56 79.69c15.709 25.643-19.6 36.758-34.816 33.782-19.71-3.856-31.027-28.769-46.1-20.875-15.073 7.894-30.006-27.876-8.08-41.039 27.274-16.373 9.77-25.888 12.22-37.894C25.54 5.047 50.558-8.275 64.05 6.921c11.352 12.787 16.918 8.213 22.107 6.506 7.483-2.462 23.817 10.344 12.075 23.904z"
        fill="#4AA6E1"
        fillOpacity={0.2}
      />
      <Path
        d="M54.737 52.526l-5.033 20.645a6.001 6.001 0 004.408 7.25l25.032 6.103c.643 7.066 6.491 7.589 8.799 7.83a.103.103 0 00.061-.189c-1.657-1.01-2.151-3.778-2.262-6.033l1.858.453a6 6 0 007.251-4.408l5.033-20.644a6.008 6.008 0 00-.702-4.54 5.997 5.997 0 00-3.706-2.711l-33.488-8.164a6.001 6.001 0 00-7.251 4.408z"
        fill="#3876AA"
      />
      <Path
        d="M96.258 62.71L82.261 59.3a.172.172 0 00-.207.126l-.718 2.945a.172.172 0 00.126.208l13.997 3.412a.172.172 0 00.207-.126l.718-2.946a.172.172 0 00-.126-.207z"
        fill="#fff"
      />
      <Path
        d="M94.26 70.909l-37.924-9.246a.172.172 0 00-.207.127l-.719 2.945a.172.172 0 00.127.208l37.923 9.245a.172.172 0 00.208-.126l.718-2.945a.172.172 0 00-.126-.208zM92.261 79.107L54.338 69.86a.172.172 0 00-.208.127l-.718 2.945a.172.172 0 00.126.208l37.924 9.245a.172.172 0 00.207-.126l.718-2.946a.172.172 0 00-.126-.207z"
        fill="#D4E5FF"
      />
      <Path
        d="M68.83 27.761l8.23 26.43a7.814 7.814 0 01-5.139 9.787l-32.045 9.979c-.26 9.24-7.82 10.397-10.8 10.9a.134.134 0 01-.096-.242c2.072-1.448 2.489-5.088 2.448-8.028l-2.379.741a7.815 7.815 0 01-9.787-5.139l-8.23-26.43a7.814 7.814 0 015.14-9.787l42.87-13.35a7.813 7.813 0 019.788 5.14z"
        fill="#4AA6E1"
      />
      <Path
        d="M38.553 37.227l-22.958 7.14a.172.172 0 00-.113.215l1.204 3.871c.028.09.124.141.215.113l22.958-7.14a.172.172 0 00.113-.215l-1.204-3.87a.172.172 0 00-.215-.114z"
        fill="#fff"
      />
      <Path
        d="M67.524 39.68L18.875 54.83a.172.172 0 00-.113.215l1.205 3.87c.029.091.125.142.215.114l48.65-15.15a.172.172 0 00.113-.215l-1.205-3.87a.172.172 0 00-.216-.113zM70.788 50.23l-48.66 15.133a.172.172 0 00-.114.215l1.204 3.871c.028.09.125.141.215.113l48.66-15.133a.172.172 0 00.114-.215l-1.204-3.871a.172.172 0 00-.215-.113z"
        fill="#D4E5FF"
      />
    </Svg>
  );
};

export default NoAdvisors;
